var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$hasPermission('skills.read'))?_c('p-edit-skill',{attrs:{"name":_vm.name}}):_c('p-not-found')}
var staticRenderFns = []

export { render, staticRenderFns }